import { Component } from "react";
import PropTypes from "prop-types";
import { Card, Row, Col, Form, Button, Table, Spinner, Badge, Modal, Alert, Dropdown } from "react-bootstrap";
import { FaFilePdf, FaLink, FaUserPlus, FaSearch, FaPlus, FaTimes, FaEnvelope, FaExternalLinkAlt, FaEye, FaUpload, FaEllipsisV } from "react-icons/fa";
import AsyncSelect from "react-select/async";
import { IMaskInput } from "react-imask";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../services/api";
import Paginacao from "../../common/pagination";
import { withRouter } from "../../common/with-router";
import { getCurrentUser } from "../../common/utils";
import { formataDataHoraExibicao, formataTelefoneExibicao } from "../../common/utils";

const MySwal = withReactContent(Swal);

const CONSELHOS = ["CRN", "COREN", "CREFITO", "CRP", "CRF", "CREF", "Outro"];
const LIMITE = 30;
const UFS = ["AC","AL","AM","AP","BA","CE","DF","ES","GO","MA","MG","MS","MT","PA","PB",
             "PE","PI","PR","RJ","RN","RO","RR","RS","SC","SE","SP","TO"];

/**
 * Indicações recebidas, na visão da operação.
 *
 * O médico indica e assina; aqui a navegadora recebe. Receber é ligar o profissional
 * declarado a um cadastro de provedor — um que já exista, ou um novo criado a partir do
 * que o médico declarou. Sem esse vínculo o indicado não aparece na operação nem recebe
 * termo.
 *
 * A tela mostra cadastros parecidos antes de deixar criar outro: duplicar profissional é
 * problema conhecido aqui.
 */
class IndicacoesRecebidas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carregando: true,
            erro: "",
            //a resposta inteira, com count -- o componente de paginação lê dela
            dados: {},
            indicacoes: [],
            //a fila abre com tudo: a operação acompanha a indicação da assinatura ao aceite,
            //e abrir só em "aguardando cadastro" escondia o resto do trabalho
            situacao: "todas",
            busca: "",
            page_numb: 1,
            //o admin enxerga mais de um programa: sem o filtro a fila vira uma lista só
            programaFiltro: "",
            programasDisponiveis: [],
            //anexo da via assinada em papel: {indicacao, tipo} enquanto o modal está aberto
            anexando: null,
            arquivoAnexo: null,
            enviandoAnexo: false,
            //detalhe: a listagem não cabe tudo que o médico declarou (telefone, e-mail,
            //autorização de contato, IP e datas) -- o modal mostra o registro inteiro
            detalhe: null,
            // recebimento
            aberta: null,
            candidatos: [],
            categoriaSugerida: null,
            categorias: [],
            categoriaEscolhida: "",
            carregandoModal: false,
            salvando: false,
            linkCopiado: null,
            // formulário da navegadora: ela preenche e o médico só assina (escopo [3])
            criando: false,
            form: this.formVazio(),
            errosForm: {},
            salvandoForm: false,
        };
    }

    formVazio = () => ({
        medico: null,
        nome_indicado: "",
        conselho: "",
        registro: "",
        registro_uf: "",
        telefone: "",
        email: "",
    });

    /** Médicos do programa, para a navegadora escolher em nome de quem é a indicação. */
    carregarMedicos = async (busca = "") => {
        try {
            const programaId = this.programaEmFoco();
            const { data } = await api.get(
                `/pessoas/prestadores/?nome=${busca}&programa_id=${programaId}&categoria=medicos&is_active=1`);
            return (data.results || []).map((m) => {
                const registro = [m.registro, m.registro_uf].filter(Boolean).join("/");
                // homônimos são comuns: o CRM no rótulo evita escolher o médico errado
                return { value: m.id, label: registro ? `${m.nome} — CRM ${registro}` : m.nome };
            });
        } catch (error) {
            console.error("Erro ao carregar médicos:", error);
            return [];
        }
    };

    validarForm = () => {
        const { form } = this.state;
        const erros = {};
        //sem programa não há a quem vincular a indicação: acontece com o admin, que navega
        //sem ambiente de programa e ainda não escolheu um no filtro
        if (!this.programaEmFoco()) {
            erros.medico = "Escolha um programa no filtro antes de registrar a indicação.";
        }
        if (!form.medico) erros.medico = "Selecione o médico que está indicando.";
        if (!form.nome_indicado.trim()) erros.nome_indicado = "Informe o nome do profissional.";
        if (!form.conselho) erros.conselho = "Informe o conselho.";
        if (!form.registro.trim()) erros.registro = "Informe o número de registro.";
        if (!form.registro_uf) erros.registro_uf = "Informe a UF.";
        if (!String(form.telefone || "").trim()) erros.telefone = "Informe o telefone.";
        this.setState({ errosForm: erros });
        return Object.keys(erros).length === 0;
    };

    criarIndicacao = async (e) => {
        e.preventDefault();
        if (!this.validarForm()) return;

        const { form } = this.state;
        this.setState({ salvandoForm: true });
        try {
            const { data } = await api.post("/pessoas/indicacoes-profissionais/", {
                medico_id: form.medico.value,
                programa_id: this.programaEmFoco(),
                nome_indicado: form.nome_indicado,
                conselho: form.conselho,
                registro: form.registro,
                registro_uf: form.registro_uf,
                telefone: form.telefone,
                email: form.email,
            });

            this.setState({ salvandoForm: false, criando: false, form: this.formVazio() });

            // a autorização de contato quem responde é o médico, ao assinar -- por isso ela
            // não está neste formulário
            await MySwal.fire({
                icon: "success",
                title: "Indicação registrada",
                text: "Envie o link ao médico para que ele leia e assine a declaração. " +
                      "Enquanto não assinada, ela fica em “Aguardando assinatura do médico”.",
                confirmButtonText: "Entendi",
                showDenyButton: !!data?.link_assinatura,
                denyButtonText: "Copiar link de assinatura",
                denyButtonColor: "#6c757d",
            }).then((escolha) => {
                if (escolha.isDenied && data?.link_assinatura) {
                    this.copiarLink(data, data.link_assinatura);
                }
            });

            this.setState({ situacao: "assinatura" }, this.carregar);
        } catch (error) {
            console.error("Erro ao criar a indicação:", error);
            this.setState({ salvandoForm: false });
            const dados = error.response?.data || {};
            const detalhe = dados.detail || Object.values(dados).flat()[0];
            MySwal.fire({ icon: "error", title: "Atenção!", showCloseButton: true,
                text: detalhe || "Não foi possível registrar a indicação. Tente novamente." });
        }
    };

    componentDidMount() {
        this.carregar();
        this.carregarCategorias();
        if (this.ehAdmin()) this.carregarProgramas();
    }

    /** Só os programas que oferecem indicação — nos demais a fila não existe. */
    carregarProgramas = async () => {
        try {
            const { data } = await api.get("/programas/?limit=200");
            const lista = (data.results || []).filter((p) => p.habilitar_indicacao_profissional);
            this.setState({ programasDisponiveis: lista });
        } catch (error) {
            console.error("Erro ao carregar os programas:", error);
        }
    };

    programaId = () => getCurrentUser()?.["ambiente_programa_id"] || "";

    /** Programa sobre o qual a tela age (criar indicação, buscar médicos).
     *  O admin navega sem ambiente de programa, então vale o que ele escolheu no filtro. */
    programaEmFoco = () => this.programaId() || this.state.programaFiltro || "";

    /** É o admin quem enxerga mais de um programa; para a navegadora a fila é a do dela. */
    ehAdmin = () => {
        const u = getCurrentUser() || {};
        return !!u.is_superuser || u.tipo_usuario === "administrador";
    };

    parametros = (page = 1) => {
        const p = [`page=${page}`, `limit=${LIMITE}`];
        //o admin escolhe o programa; sem escolha, a API já recorta pelos que oferecem indicação
        const programa = this.ehAdmin() ? this.state.programaFiltro : this.programaId();
        if (programa) p.push(`programa_id=${programa}`);
        if (this.state.situacao === "aguardando") p.push("sem_indicado=true", "status=ativa");
        if (this.state.situacao === "assinatura") p.push("status=rascunho");
        if (this.state.situacao === "vinculadas") p.push("sem_indicado=false", "status=ativa");
        if (this.state.situacao === "encerradas") p.push("status=cancelada");
        if (this.state.busca.trim()) p.push(`busca=${encodeURIComponent(this.state.busca.trim())}`);
        return p.join("&");
    };

    onClickPagina = (num_page) => this.carregar(num_page);

    carregar = async (page = 1) => {
        this.setState({ carregando: true, erro: "" });
        try {
            const { data } = await api.get(`/pessoas/indicacoes-profissionais/?${this.parametros(page)}`);
            this.setState({ carregando: false, dados: data, indicacoes: data.results || [],
                            page_numb: page });
        } catch (error) {
            const detalhe = error.response?.data?.detail;
            this.setState({
                carregando: false,
                erro: detalhe || "Não foi possível carregar as indicações. Tente novamente.",
            });
        }
    };

    carregarCategorias = async () => {
        try {
            const { data } = await api.get("/profissionais/categorias-multiprofissionais/?limit=100");
            this.setState({ categorias: (data.results || []).filter((c) => c.status !== false) });
        } catch (error) {
            // sem a lista o modal ainda funciona para vincular a cadastro existente
            console.error("Erro ao carregar as categorias:", error);
        }
    };

    abrirRecebimento = async (indicacao) => {
        this.setState({ aberta: indicacao, carregandoModal: true, candidatos: [],
                        categoriaSugerida: null, categoriaEscolhida: "" });
        try {
            const { data } = await api.get(`/pessoas/indicacoes-profissionais/${indicacao.id}/receber/`);
            this.setState({
                carregandoModal: false,
                candidatos: data.candidatos || [],
                categoriaSugerida: data.categoria_multiprofissional_sugerida || null,
                categoriaEscolhida: data.categoria_multiprofissional_sugerida?.id || "",
            });
        } catch (error) {
            console.error("Erro ao abrir o recebimento:", error);
            this.setState({ carregandoModal: false });
        }
    };

    fechar = () => this.setState({ aberta: null, candidatos: [], categoriaEscolhida: "" });

    enviarVinculo = async (corpo, mensagem) => {
        this.setState({ salvando: true });
        try {
            await api.post(`/pessoas/indicacoes-profissionais/${this.state.aberta.id}/receber/`, corpo);
            this.setState({ salvando: false, aberta: null });

            // recarrega ANTES do aviso: com a lista atualizada só depois de fechar o diálogo,
            // a linha continuava mostrando "Receber" e a operadora recebia de novo
            await this.carregar();

            MySwal.fire({ icon: "success", title: "Indicação recebida", text: mensagem,
                          confirmButtonText: "Entendi" });
        } catch (error) {
            this.setState({ salvando: false });
            const dados = error.response?.data || {};
            const texto = dados.detail || Object.values(dados).flat()[0] ||
                          "Não foi possível receber a indicação. Tente novamente.";
            MySwal.fire({ icon: "error", title: "Atenção!", showCloseButton: true, text: texto });
        }
    };

    vincularExistente = (candidato) =>
        this.enviarVinculo({ indicado_id: candidato.id },
            `${candidato.nome} passou a constar como profissional indicado.`);

    criarCadastro = () => {
        if (!this.state.categoriaEscolhida) {
            MySwal.fire({ icon: "warning", title: "Escolha a categoria",
                          text: "Informe a categoria do profissional para criar o cadastro." });
            return;
        }
        this.enviarVinculo(
            { criar: true, categoria_multiprofissional_id: this.state.categoriaEscolhida },
            "O cadastro foi criado com os dados declarados e vinculado ao programa. Complete as informações em Provedores."
        );
    };

    /** Estado do termo daquela indicação: só existe depois que o indicado tem cadastro. */
    renderSituacaoTermo = (i) => {
        if (!i.dados_indicado) return <span className="text-muted small">—</span>;
        if (i.data_aceite_termo) {
            //quem anexou em papel precisa se distinguir de quem aceitou na tela: a evidência
            //é outra, e a operação decide diferente sabendo disso
            const selo = (
                <Badge bg="success">
                    Aceito em {formataDataHoraExibicao(i.data_aceite_termo)}
                    {i.canal_aceite_termo === "upload" && " (anexado)"}
                </Badge>
            );
            //o comprovante aqui evita ter de procurar o PDF no cadastro do profissional
            return i.termo_comprovante_url ? (
                <a href={i.termo_comprovante_url} target="_blank" rel="noopener noreferrer"
                   title="Abrir o termo assinado">{selo}</a>
            ) : selo;
        }
        return <Badge bg="warning">Aguardando aceite</Badge>;
    };

    /** Anexa a via assinada em papel. É o caminho de exceção: o normal é o médico assinar
     *  pelo link e o profissional aceitar pela tela. */
    enviarAnexo = async (e) => {
        e.preventDefault();
        const { anexando, arquivoAnexo } = this.state;
        if (!anexando || !arquivoAnexo) return;

        const corpo = new FormData();
        corpo.append("tipo", anexando.tipo);
        corpo.append("arquivo", arquivoAnexo);

        this.setState({ enviandoAnexo: true });
        try {
            await api.post(
                `/pessoas/indicacoes-profissionais/${anexando.indicacao.id}/upload-documento/`,
                corpo, { headers: { "Content-Type": "multipart/form-data" } });
            this.setState({ enviandoAnexo: false, anexando: null, arquivoAnexo: null });
            await this.carregar(this.state.page_numb);
            MySwal.fire({ icon: "success", title: "Documento anexado",
                text: anexando.tipo === "declaracao"
                    ? "A declaração assinada foi anexada e a indicação passa a valer."
                    : "O termo assinado foi anexado e consta como aceito." });
        } catch (error) {
            console.error("Erro ao anexar o documento:", error);
            this.setState({ enviandoAnexo: false });
            const dados = error.response?.data || {};
            MySwal.fire({ icon: "error", title: "Atenção!", showCloseButton: true,
                text: dados.detail || Object.values(dados).flat()[0] ||
                      "Não foi possível anexar o documento. Tente novamente." });
        }
    };

    /** Envia o link por e-mail: a assinatura ao médico, o aceite ao profissional indicado.
     *  Sem isto a operação copiava o link e mandava por fora do sistema. */
    enviarPorEmail = async (indicacao, tipo) => {
        const aoMedico = tipo === "assinatura";
        const destino = aoMedico
            ? (indicacao.dados_medico?.email || "")
            : (indicacao.dados_indicado?.email || indicacao.email || "");
        const quem = aoMedico
            ? (indicacao.dados_medico?.nome || "o médico")
            : (indicacao.dados_indicado?.nome || indicacao.nome_indicado || "o profissional");

        const escolha = await MySwal.fire({
            title: aoMedico ? "Enviar link de assinatura" : "Enviar termo por e-mail",
            html: `O link será enviado para <strong>${quem}</strong>.`,
            input: "email",
            inputValue: destino,
            inputLabel: "E-mail do destinatário",
            inputPlaceholder: "nome@dominio.com",
            showCancelButton: true,
            confirmButtonText: "Enviar",
            cancelButtonText: "Cancelar",
            inputValidator: (valor) =>
                (!valor || !valor.includes("@")) && "Informe um e-mail válido.",
        });
        if (!escolha.isConfirmed) return;

        try {
            const { data } = await api.post(
                `/pessoas/indicacoes-profissionais/${indicacao.id}/enviar-link/`,
                { tipo, email: escolha.value });
            MySwal.fire({ icon: "success", title: "E-mail enviado",
                          text: data?.detail || `Enviado para ${escolha.value}.` });
        } catch (error) {
            console.error("Erro ao enviar o link por e-mail:", error);
            const dados = error.response?.data || {};
            MySwal.fire({ icon: "error", title: "Atenção!", showCloseButton: true,
                text: dados.detail || Object.values(dados).flat()[0] ||
                      "Não foi possível enviar o e-mail. Tente novamente." });
        }
    };

    /** O link já vem com a indicação: sem ela o aceite não contaria para esta indicação. */
    copiarLinkAceite = (indicacao) => this.copiarLink(indicacao, indicacao.link_aceite_termo);

    copiarLink = async (indicacao, link) => {
        try {
            await navigator.clipboard.writeText(link);
            this.setState({ linkCopiado: indicacao.id });
            setTimeout(() => this.setState({ linkCopiado: null }), 2500);
        } catch (error) {
            console.error("Erro ao copiar o link:", error);
            MySwal.fire({ icon: "info", title: "Copie o link", text: link });
        }
    };

    /** Encerrar pela operação: troca de equipe, rascunho que não será assinado, engano.
     *  Nunca apaga — muda o status e o registro fica no histórico. */
    encerrarIndicacao = async (indicacao) => {
        const rascunho = indicacao.status === "rascunho";
        const escolha = await MySwal.fire({
            title: "Encerrar indicação?",
            html: `<strong>${indicacao.nome_indicado}</strong> deixará de constar como indicado(a)
                   por ${indicacao.dados_medico?.nome || "este médico"}. O registro permanece no
                   histórico.` + (rascunho
                       ? " O link de assinatura enviado ao médico deixa de valer." : ""),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, encerrar",
            cancelButtonText: "Manter",
        });
        if (!escolha.isConfirmed) return;

        try {
            await api.put(`/pessoas/indicacoes-profissionais/${indicacao.id}/`, {
                status: "cancelada",
                motivo_cancelamento: "Encerrada pela operação.",
            });
            await this.carregar();
        } catch (error) {
            console.error("Erro ao encerrar a indicação:", error);
            const dados = error.response?.data || {};
            MySwal.fire({ icon: "error", title: "Atenção!", showCloseButton: true,
                text: dados.detail || Object.values(dados).flat()[0] ||
                      "Não foi possível encerrar a indicação. Tente novamente." });
        }
    };

    renderSituacao = (i) => {
        if (i.status === "cancelada") return <Badge bg="secondary">Encerrada</Badge>;
        //aberta pela operação e ainda não assinada pelo médico
        if (i.status === "rascunho") return <Badge bg="warning">Aguardando assinatura</Badge>;
        //azul separa do "Aguardando assinatura", que é laranja: são filas diferentes
        if (!i.dados_indicado) return <Badge bg="info">Aguardando cadastro</Badge>;
        return <Badge bg="success">Vinculada</Badge>;
    };

    renderLinha = (i) => (
        <tr key={i.id}>
            <td>
                {i.nome_indicado}
                {i.dados_indicado && (
                    <div className="text-muted small">
                        {/* leva direto ao cadastro: sem isto a navegadora ia procurar em Provedores */}
                        Cadastro:{" "}
                        <a href={`/prestadores/edit/${i.dados_indicado.id}`}
                           target="_blank" rel="noopener noreferrer">
                            {i.dados_indicado.nome} <FaExternalLinkAlt size={10} />
                        </a>
                    </div>
                )}
            </td>
            <td>{[i.conselho, i.registro, i.registro_uf].filter(Boolean).join(" ") || "-"}</td>
            <td>
                {i.dados_medico?.nome || "-"}
                {/* homônimos são comuns: sem o CRM não dá para saber qual médico indicou */}
                {i.dados_medico?.registro && (
                    <div className="text-muted small">
                        CRM {[i.dados_medico.registro, i.dados_medico.registro_uf].filter(Boolean).join("/")}
                    </div>
                )}
            </td>
            {this.ehAdmin() && <td className="small">{i.dados_programa?.nome || "-"}</td>}
            <td>{i.data_indicacao ? formataDataHoraExibicao(i.data_indicacao) : "-"}</td>
            <td>{this.renderSituacao(i)}</td>
            <td>{this.renderSituacaoTermo(i)}</td>
            <td className="text-end text-nowrap">
                {/* só a ação que o momento pede fica visível; o resto vai no menu, senão
                    a coluna cresce mais que os próprios dados da indicação */}
                {!i.dados_indicado && i.status === "ativa" && (
                    <Button variant="success" size="sm" className="me-1" onClick={() => this.abrirRecebimento(i)}>
                        <FaLink className="me-1" /> Receber
                    </Button>
                )}

                <Dropdown align="end" className="d-inline-block">
                    <Dropdown.Toggle variant="light" size="sm" id={`acoes-indicacao-${i.id}`}
                                     title="Ações desta indicação">
                        <FaEllipsisV />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => this.setState({ detalhe: i })}>
                            <FaEye className="me-2" /> Ver todos os dados
                        </Dropdown.Item>

                        {i.declaracao_url && (
                            <Dropdown.Item href={i.declaracao_url} target="_blank" rel="noopener noreferrer">
                                <FaFilePdf className="me-2" /> Abrir declaração
                            </Dropdown.Item>
                        )}
                        {i.termo_comprovante_url && (
                            <Dropdown.Item href={i.termo_comprovante_url} target="_blank" rel="noopener noreferrer">
                                <FaFilePdf className="me-2" /> Abrir termo assinado
                            </Dropdown.Item>
                        )}

                        {i.status === "rascunho" && (
                            <>
                                <Dropdown.Divider />
                                <Dropdown.Header>Declaração do médico</Dropdown.Header>
                                {i.link_assinatura && (
                                    <>
                                        <Dropdown.Item onClick={() => this.copiarLink(i, i.link_assinatura)}>
                                            <FaLink className="me-2" />
                                            {this.state.linkCopiado === i.id ? "Link copiado" : "Copiar link de assinatura"}
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.enviarPorEmail(i, "assinatura")}>
                                            <FaEnvelope className="me-2" /> Enviar link por e-mail
                                        </Dropdown.Item>
                                    </>
                                )}
                                <Dropdown.Item onClick={() => this.setState({ anexando: { indicacao: i, tipo: "declaracao" }, arquivoAnexo: null })}>
                                    <FaUpload className="me-2" /> Anexar declaração assinada
                                </Dropdown.Item>
                            </>
                        )}

                        {i.dados_indicado && i.status === "ativa" && !i.data_aceite_termo && (
                            <>
                                <Dropdown.Divider />
                                <Dropdown.Header>Termo do profissional</Dropdown.Header>
                                {i.link_aceite_termo && (
                                    <>
                                        <Dropdown.Item onClick={() => this.copiarLinkAceite(i)}>
                                            <FaLink className="me-2" />
                                            {this.state.linkCopiado === i.id ? "Link copiado" : "Copiar link do termo"}
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.enviarPorEmail(i, "aceite")}>
                                            <FaEnvelope className="me-2" /> Enviar termo por e-mail
                                        </Dropdown.Item>
                                    </>
                                )}
                                <Dropdown.Item onClick={() => this.setState({ anexando: { indicacao: i, tipo: "termo" }, arquivoAnexo: null })}>
                                    <FaUpload className="me-2" /> Anexar termo assinado
                                </Dropdown.Item>
                            </>
                        )}

                        {i.status !== "cancelada" && (
                            <>
                                <Dropdown.Divider />
                                <Dropdown.Item className="text-danger" onClick={() => this.encerrarIndicacao(i)}>
                                    <FaTimes className="me-2" /> Encerrar indicação
                                </Dropdown.Item>
                            </>
                        )}
                    </Dropdown.Menu>
                </Dropdown>
            </td>
        </tr>
    );

    renderFormulario = () => {
        const { criando, form, errosForm, salvandoForm } = this.state;
        if (!criando) return null;

        const troca = (campo) => (e) => this.setState((prev) => ({
            form: { ...prev.form, [campo]: e.target.value },
            errosForm: { ...prev.errosForm, [campo]: "" },
        }));

        return (
            <Modal show onHide={() => this.setState({ criando: false })} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="h5">Nova indicação</Modal.Title>
                </Modal.Header>
                <Form onSubmit={this.criarIndicacao}>
                    <Modal.Body>
                        <p className="text-muted">
                            Preencha os dados do profissional indicado. A declaração será enviada ao
                            médico <strong>apenas para assinatura</strong> — a autorização de contato
                            é respondida por ele.
                        </p>

                        <Form.Group className="mb-3">
                            <Form.Label>Médico que está indicando <span className="text-danger">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                loadOptions={this.carregarMedicos}
                                value={form.medico}
                                placeholder="Buscar médico..."
                                noOptionsMessage={() => "Nenhum médico encontrado"}
                                onChange={(op) => this.setState((prev) => ({
                                    form: { ...prev.form, medico: op },
                                    errosForm: { ...prev.errosForm, medico: "" },
                                }))}
                            />
                            {errosForm.medico && <div className="text-danger small mt-1">{errosForm.medico}</div>}
                        </Form.Group>

                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome do(a) profissional indicado(a) <span className="text-danger">*</span></Form.Label>
                                    <Form.Control value={form.nome_indicado} onChange={troca("nome_indicado")}
                                                  isInvalid={!!errosForm.nome_indicado} />
                                    <Form.Control.Feedback type="invalid">{errosForm.nome_indicado}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Profissão / Conselho <span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={form.conselho} onChange={troca("conselho")}
                                                 isInvalid={!!errosForm.conselho}>
                                        <option value="">Selecione</option>
                                        {CONSELHOS.map((c) => <option key={c} value={c}>{c}</option>)}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">{errosForm.conselho}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>UF <span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={form.registro_uf} onChange={troca("registro_uf")}
                                                 isInvalid={!!errosForm.registro_uf}>
                                        <option value="">UF</option>
                                        {UFS.map((u) => <option key={u} value={u}>{u}</option>)}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">{errosForm.registro_uf}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nº de registro profissional <span className="text-danger">*</span></Form.Label>
                                    <Form.Control value={form.registro} onChange={troca("registro")}
                                                  isInvalid={!!errosForm.registro} />
                                    <Form.Control.Feedback type="invalid">{errosForm.registro}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Telefone <span className="text-danger">*</span></Form.Label>
                                    <Form.Control as={IMaskInput} unmask="typed" mask="(00) 00000-0000"
                                                  value={form.telefone}
                                                  onAccept={(valor) => this.setState((prev) => ({
                                                      form: { ...prev.form, telefone: valor },
                                                      errosForm: { ...prev.errosForm, telefone: "" },
                                                  }))}
                                                  isInvalid={!!errosForm.telefone} />
                                    <Form.Control.Feedback type="invalid">{errosForm.telefone}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control type="email" value={form.email} onChange={troca("email")} />
                                    <Form.Text muted>Opcional.</Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={() => this.setState({ criando: false })}>
                            Cancelar
                        </Button>
                        <Button variant="success" type="submit" disabled={salvandoForm}>
                            {salvandoForm ? <span className="spinner-border spinner-border-sm"></span>
                                          : <><FaPlus className="me-1" /> Registrar e gerar link</>}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    };

    renderAnexo = () => {
        const { anexando, arquivoAnexo, enviandoAnexo } = this.state;
        if (!anexando) return null;

        const daDeclaracao = anexando.tipo === "declaracao";
        const i = anexando.indicacao;

        return (
            <Modal show onHide={() => this.setState({ anexando: null, arquivoAnexo: null })} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="h5">
                        {daDeclaracao ? "Anexar declaração assinada" : "Anexar termo assinado"}
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={this.enviarAnexo}>
                    <Modal.Body>
                        <p className="text-muted">
                            {daDeclaracao ? (
                                <>Use quando <strong>{i.dados_medico?.nome || "o médico"}</strong> assinar
                                a declaração fora do sistema. A indicação passa a valer como assinada.</>
                            ) : (
                                <>Use quando <strong>{i.dados_indicado?.nome || i.nome_indicado}</strong> aceitar
                                o termo fora do sistema. O aceite fica registrado no cadastro do profissional.</>
                            )}
                        </p>

                        <Form.Group className="mb-3">
                            <Form.Label>Documento assinado (PDF)</Form.Label>
                            <Form.Control type="file" accept="application/pdf"
                                          onChange={(e) => this.setState({ arquivoAnexo: e.target.files[0] })} />
                            <Form.Text muted>
                                Somente PDF. O documento fica guardado como evidência do aceite e
                                aparece no lugar do comprovante eletrônico.
                            </Form.Text>
                        </Form.Group>

                        <Alert variant="warning" className="mb-0 small">
                            O registro guarda que este documento foi <strong>anexado pela operação</strong>,
                            e não assinado no sistema.
                        </Alert>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={() => this.setState({ anexando: null, arquivoAnexo: null })}>
                            Cancelar
                        </Button>
                        <Button variant="success" type="submit" disabled={!arquivoAnexo || enviandoAnexo}>
                            {enviandoAnexo ? <span className="spinner-border spinner-border-sm"></span>
                                           : <><FaUpload className="me-1" /> Anexar</>}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    };

    /** Tudo que o médico declarou, mais o rastro da assinatura e do aceite.
     *  A listagem mostra só o essencial; telefone e e-mail só existiam aqui. */
    renderDetalhe = () => {
        const i = this.state.detalhe;
        if (!i) return null;

        const linha = (rotulo, valor) => (
            <tr><th style={{ width: "38%" }}>{rotulo}</th><td>{valor || "-"}</td></tr>
        );
        const data = (v) => (v ? formataDataHoraExibicao(v) : "");

        return (
            <Modal show onHide={() => this.setState({ detalhe: null })} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="h5">Indicação de {i.nome_indicado}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h6 className="text-uppercase text-muted small">Profissional indicado</h6>
                    <Table size="sm" className="custom-table mb-4">
                        <tbody>
                            {linha("Nome declarado", i.nome_indicado)}
                            {linha("Conselho", [i.conselho, i.registro, i.registro_uf].filter(Boolean).join(" "))}
                            {linha("Telefone", formataTelefoneExibicao(i.telefone))}
                            {linha("E-mail", i.email)}
                            {linha("Autoriza contato", i.autoriza_contato === null || i.autoriza_contato === undefined
                                ? "-" : (i.autoriza_contato ? "Sim" : "Não"))}
                            {linha("Cadastro vinculado", i.dados_indicado ? (
                                <a href={`/prestadores/edit/${i.dados_indicado.id}`}
                                   target="_blank" rel="noopener noreferrer">
                                    {i.dados_indicado.nome} <FaExternalLinkAlt size={10} />
                                </a>
                            ) : "ainda não vinculado")}
                        </tbody>
                    </Table>

                    <h6 className="text-uppercase text-muted small">Médico que indicou</h6>
                    <Table size="sm" className="custom-table mb-4">
                        <tbody>
                            {linha("Nome", i.dados_medico?.nome)}
                            {linha("CRM", [i.dados_medico?.registro, i.dados_medico?.registro_uf]
                                .filter(Boolean).join("/"))}
                            {linha("Programa", i.dados_programa?.nome)}
                        </tbody>
                    </Table>

                    <h6 className="text-uppercase text-muted small">Registro e assinatura</h6>
                    <Table size="sm" className="custom-table mb-0">
                        <tbody>
                            {linha("Situação", this.renderSituacao(i))}
                            {linha("Indicada em", data(i.data_indicacao))}
                            {/* quem preencheu: vazio quando o próprio médico abriu pelo link */}
                            {linha("Registrada por", i.criado_por_nome || "o próprio médico")}
                            {linha("Assinada em", data(i.data_assinatura)
                                + (i.canal_assinatura === "upload" ? " — documento anexado pela operação" : ""))}
                            {linha("IP da assinatura", i.ip_assinatura)}
                            {linha("Termo aceito em", data(i.data_aceite_termo)
                                + (i.canal_aceite_termo === "upload" ? " — documento anexado pela operação" : ""))}
                            {i.status === "cancelada" && linha("Encerrada em", data(i.data_cancelamento))}
                            {i.status === "cancelada" && linha("Encerrada por", i.cancelada_por_nome)}
                            {i.status === "cancelada" && linha("Motivo", i.motivo_cancelamento)}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <div>
                        {i.declaracao_url && (
                            <Button variant="light" size="sm" className="me-2" href={i.declaracao_url}
                                    target="_blank" rel="noopener noreferrer">
                                <FaFilePdf className="me-1" /> Declaração
                            </Button>
                        )}
                        {i.termo_comprovante_url && (
                            <Button variant="light" size="sm" href={i.termo_comprovante_url}
                                    target="_blank" rel="noopener noreferrer">
                                <FaFilePdf className="me-1" /> Termo assinado
                            </Button>
                        )}
                    </div>
                    <Button variant="secondary" onClick={() => this.setState({ detalhe: null })}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    renderModal = () => {
        const { aberta, candidatos, categorias, categoriaEscolhida, categoriaSugerida,
                carregandoModal, salvando } = this.state;
        if (!aberta) return null;

        return (
            <Modal show onHide={this.fechar} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="h5">Receber indicação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-muted">
                        Declarado por <strong>{aberta.dados_medico?.nome}</strong> em{" "}
                        {aberta.data_indicacao ? formataDataHoraExibicao(aberta.data_indicacao) : "-"}.
                    </p>

                    <Table size="sm" className="custom-table mb-4">
                        <tbody>
                            <tr><th style={{ width: "35%" }}>Profissional</th><td>{aberta.nome_indicado}</td></tr>
                            <tr><th>Conselho</th>
                                <td>{[aberta.conselho, aberta.registro, aberta.registro_uf].filter(Boolean).join(" ") || "-"}</td></tr>
                            <tr><th>Telefone</th><td>{formataTelefoneExibicao(aberta.telefone) || "-"}</td></tr>
                            <tr><th>E-mail</th><td>{aberta.email || "-"}</td></tr>
                            <tr><th>Autoriza contato</th><td>{aberta.autoriza_contato ? "Sim" : "Não"}</td></tr>
                        </tbody>
                    </Table>

                    {carregandoModal ? (
                        <div className="text-center py-3"><Spinner animation="border" size="sm" /></div>
                    ) : (
                        <>
                            <h6>Cadastros parecidos</h6>
                            {candidatos.length === 0 ? (
                                <p className="text-muted small">
                                    Nenhum cadastro com o mesmo registro, nome ou e-mail.
                                </p>
                            ) : (
                                <>
                                    <p className="text-muted small">
                                        Se um destes for a mesma pessoa, vincule — evita cadastro duplicado.
                                    </p>
                                    <Table responsive size="sm" className="custom-table mb-4">
                                        <thead>
                                            <tr>
                                                <th>Nome</th><th>Categoria</th><th>Conselho</th>
                                                <th>Contato</th><th>No programa</th><th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {candidatos.map((c) => (
                                                <tr key={c.id}>
                                                    <td>{c.nome}</td>
                                                    {/* um médico homônimo também entra na busca: a categoria denuncia */}
                                                    <td className="small">{c.categoria || "-"}</td>
                                                    <td>{[c.registro, c.registro_uf].filter(Boolean).join(" ") || "-"}</td>
                                                    <td className="small">{c.email || c.celular || "-"}</td>
                                                    <td>{c.no_programa ? "Sim" : "Não"}</td>
                                                    <td className="text-end">
                                                        <Button variant="outline-success" size="sm" disabled={salvando}
                                                                onClick={() => this.vincularExistente(c)}>
                                                            Vincular
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </>
                            )}

                            <h6>Criar novo cadastro</h6>
                            <p className="text-muted small">
                                O cadastro nasce com o que o médico declarou; complete os demais dados
                                depois, em Provedores.
                            </p>
                            {!categoriaSugerida && (
                                <Alert variant="light" className="border py-2 small">
                                    O conselho <strong>{aberta.conselho || "informado"}</strong> não tem
                                    categoria equivalente cadastrada — escolha a categoria do profissional.
                                </Alert>
                            )}
                            <Row className="align-items-end">
                                <Col md={7}>
                                    <Form.Group>
                                        <Form.Label>Categoria do profissional*</Form.Label>
                                        <Form.Select value={categoriaEscolhida}
                                                     onChange={(e) => this.setState({ categoriaEscolhida: e.target.value })}>
                                            <option value="">Selecione</option>
                                            {categorias.map((c) => (
                                                <option key={c.id} value={c.id}>{c.nome}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={5} className="mt-3 mt-md-0">
                                    <Button variant="success" onClick={this.criarCadastro} disabled={salvando}>
                                        {salvando ? <span className="spinner-border spinner-border-sm"></span>
                                                  : <><FaUserPlus className="me-1" /> Criar e vincular</>}
                                    </Button>
                                </Col>
                            </Row>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    render() {
        const { carregando, erro, indicacoes, situacao, busca } = this.state;

        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col sm={12} lg={12}>
                        <h4 className="page-title mb-0">Indicações Recebidas</h4>
                        <small className="text-white">
                            Profissionais indicados pelos médicos. Receber é ligar a indicação a um cadastro de provedor.
                        </small>
                    </Col>
                </Row>

                <Card className="cardDestaque mb-4">
                    <Card.Body>
                        <Row className="align-items-end">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Situação</Form.Label>
                                    <Form.Select value={situacao}
                                                 onChange={(e) => this.setState({ situacao: e.target.value }, () => this.carregar())}>
                                        <option value="todas">Todas</option>
                                        <option value="aguardando">Aguardando cadastro</option>
                                        <option value="assinatura">Aguardando assinatura do médico</option>
                                        <option value="vinculadas">Vinculadas</option>
                                        <option value="encerradas">Encerradas</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {this.ehAdmin() && (
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Programa</Form.Label>
                                        <Form.Select value={this.state.programaFiltro}
                                                     onChange={(e) => this.setState(
                                                         { programaFiltro: e.target.value }, () => this.carregar())}>
                                            <option value="">Todos os programas</option>
                                            {this.state.programasDisponiveis.map((p) => (
                                                <option key={p.id} value={p.id}>{p.nome}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            )}
                            <Col md={this.ehAdmin() ? 2 : 5}>
                                <Form.Group>
                                    <Form.Label>Buscar</Form.Label>
                                    <Form.Control value={busca} placeholder="Profissional, registro ou médico"
                                                  onChange={(e) => this.setState({ busca: e.target.value })}
                                                  onKeyDown={(e) => e.key === "Enter" && this.carregar()} />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mt-3 mt-md-0 d-flex gap-2">
                                <Button variant="primary" onClick={() => this.carregar()}>
                                    <FaSearch className="me-1" /> Filtrar
                                </Button>
                                {/* escopo [3]: a navegadora preenche e o médico só assina */}
                                <Button variant="success" onClick={() => this.setState({ criando: true })}>
                                    <FaPlus className="me-1" /> Nova indicação
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Card className="cardDestaque">
                    <Card.Body>
                        {carregando ? (
                            <div className="text-center py-4"><Spinner animation="border" /></div>
                        ) : erro ? (
                            <Alert variant="danger" className="mb-0">{erro}</Alert>
                        ) : indicacoes.length === 0 ? (
                            <p className="text-muted mb-0">Nenhuma indicação nesta situação.</p>
                        ) : (
                            <Table responsive className="custom-table">
                                <thead>
                                    <tr>
                                        <th>Profissional indicado</th>
                                        <th>Conselho</th>
                                        <th>Indicado por</th>
                                        {this.ehAdmin() && <th>Programa</th>}
                                        <th>Data</th>
                                        <th>Situação</th>
                                        <th>Termo</th>
                                        <th className="text-end">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>{indicacoes.map(this.renderLinha)}</tbody>
                            </Table>
                        )}
                        {!carregando && !erro && indicacoes.length > 0 && (
                            <Paginacao dados={this.state.dados} loading={carregando} limit={LIMITE}
                                       page_numb={this.state.page_numb}
                                       _onClickPagina={this.onClickPagina} />
                        )}
                    </Card.Body>
                </Card>

                {this.renderAnexo()}
                {this.renderDetalhe()}
                {this.renderFormulario()}
                {this.renderModal()}
            </div>
        );
    }
}

IndicacoesRecebidas.propTypes = {
    router: PropTypes.object,
};

export default withRouter(IndicacoesRecebidas);
